/**
 * Created by Ning Jiang on 4/27/2016.
 */

import {ParsedInitData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedInitData";
import {IBlankInitData} from "./IBlankServerData";
import {IServerData} from "@nolimitcity/slot-game/bin/core/server/data/IServerData";
import {WGServerDataParser} from "../WGServerDataParser";
import {FeatureBuyTimesBetValue} from "@nolimitcity/slot-launcher/bin/plugins/apiplugin/bethandler/BetFeatureController";

export class WGParsedInitData extends ParsedInitData {
    doReelNudge: boolean[];
    extraSymbolsOnTop?: string[][];
    wildMultipliers: number[];
    triggerWarriorSymbol: string;
    actualReels: string[][];
    freespinMultiplier: number;
    superFreespin: boolean;
    lockedFSWildMultiplier: number[];
    lockedWildReelsAfter: boolean[];
    lockedWildReelsBefore: boolean[];
    featureBuyTimesBetValue: FeatureBuyTimesBetValue[];
    accumulatedRoundWin :string;

    constructor(rawData: IBlankInitData, dataParser: WGServerDataParser) {
        super(rawData, dataParser);
        this.wildMultipliers = this.parsetWildMultipliers(rawData.wildMultipliers);
        this.doReelNudge = this.parseDoReelNudge(rawData.doReelNudge);
        this.extraSymbolsOnTop = this.parseExtraSymbolOnTop(rawData.extraSymbolsOnTop);
        this.triggerWarriorSymbol = this.parseTriggerWarriorSymbol(rawData.triggerWarriorSymbol);
        this.actualReels = this.parseActualReels(rawData);
        this.freespinMultiplier = this.parsefreespinMultiplier(rawData.freespinMultiplier);
        this.superFreespin = this.parseSuperFreespin(rawData.superFreespin);
        this.lockedFSWildMultiplier = this.parseLockedFSWildMultiplier(rawData.lockedFSWildMultiplier);
        this.lockedWildReelsAfter = this.parseLockedWildReelsAfter(rawData.lockedWildReelsAfter);
        this.lockedWildReelsBefore = this.parseLockedWildReelsBefore(rawData.lockedWildReelsBefore);
        this.featureBuyTimesBetValue = rawData.featureBuyTimesBetValue;
        this.accumulatedRoundWin = rawData.accumulatedRoundWin;
    }

    private parsetWildMultipliers(wildMultipliers: number[]): number[] {
        return wildMultipliers;
    }

    private parseDoReelNudge(doReelNudge: boolean[]): boolean[] {
        return doReelNudge;
    }

    private parseExtraSymbolOnTop(extraSymbolsOnTop: string[][] | undefined): string[][] | undefined {
        return extraSymbolsOnTop;
    }

    private parseTriggerWarriorSymbol(triggerWarriorSymbol: string): string {
        return triggerWarriorSymbol;
    }

    private parseActualReels(rawData: IServerData): string[][] {
        return WGServerDataParser.parseStackedSymbolsInReels(rawData.reels, undefined, true);
    }

    private parsefreespinMultiplier(freespinMultiplier: number): number {
        return freespinMultiplier;
    }

    private parseSuperFreespin(superFreespin: boolean): boolean {
        return superFreespin;
    }

    private parseLockedFSWildMultiplier(lockedFSWildMultiplier: number[]): number[] {
        return lockedFSWildMultiplier;
    }

    private parseLockedWildReelsAfter(lockedWildReelsAfter: boolean[]): boolean[] {
        return lockedWildReelsAfter;
    }

    private parseLockedWildReelsBefore(lockedWildReelsBefore: boolean[]): boolean[] {
        return lockedWildReelsBefore;
    }
}